import BaseHeading from "../baseComponents/baseHeading.js";
import BaseImage from "../baseComponents/baseImage.js";
import useColors from "../customHooks/useColors.js";

const RegionSelector = ({ data /* [{name, icon, isSelected, color}] */, setSelectedRegion,  }) => {
  const [currentColors] = useColors();
  

  const styles = {
    navDiv: {
      backgroundColor: currentColors.septenary,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      padding: "1em",
      marginTop: "1em",
      gap: "0.5em",
    },
    navButton: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
      gap: "1em",
      border: 0,
    },
    smallIcon: {
      width: "1.3rem",
    },
  };

  return (
    <div style={styles.navDiv}>
      {data.map((region) => {
        return (
          <button
            key={region.name}
            style={{
              ...styles.navButton,
              backgroundColor:
                region.isSelected === true
                  ? currentColors.quinary
                  : currentColors.septenary,
            }}
            onClick={() => {
              setSelectedRegion(region.name);
            }}
          >
            <BaseImage
              buildSrcFromConnection={false}
              style={styles.smallIcon}
              src={region.icon}
            />
            <BaseHeading bold style={{ color: region.color ? region.color : currentColors.primary }} h3>
              {region.name}
            </BaseHeading>
          </button>
        );
      })}
    </div>
  );

 
};

export default RegionSelector;
